<template>
    <div>
        <form novalidate @change="eventActivateUpdateFlag('Prices')">
            <div v-if="isLoadingStuff" class="text-center p-3">
                <loader></loader>
            </div>

            <div v-else>
                <h3 class="mt-3">Product Pricing</h3>
                <div class="mb-2" v-if="hasGroupRulesAssociated">
                    <span class="fs-small color-1">Editing is only available if you don't have any Rule Groups associated to this event</span>
                </div>

                <pricingManager 
                    :showHeader="false" 
                    v-model="genderPrices"
                    :isEventEditMode="true"
                    :group="getSelectedEvent"
                    :priceTypeConfig="{isDisable: !this.isCreatingSingleEvent, type: 'event'}"
                    :disabled="hasGroupRulesAssociated"/>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import SplitPriceEditor from '../../../components/inventory/products/SplitPriceEditor'
    import Loader from '@/tools/loaders/loader1'

    import PricingManager from '@/components/inventory/products/components/PricingManager'

    export default {
        data: function() {
            return {
                selectedPrincingType: null,
                isLoadingTypes: false,
                isLoadingTaxes: false,
                isLoadingAudienceTypes: false,
                runUpdateTypeCounter: 0
            }
        },
        mixins: [],
        props: {
            validations: {
                type: Object
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent',
                'isCreatingSingleEvent',
                'getVatTypes',
                'getBasePrices'
            ]),
            genderPrices: {
                get() {
                    return this.getSelectedEvent.eventGenderPrices;
                },
                set(value) {
                    this.$store.commit('UPDATE_SELECTED_EVENT_PRICES', value);
                }
            },
            taxes: function () {
                return this.getVatTypes;
            },
            hasGroupRulesAssociated() {
                if (!this.getSelectedEvent.eventPriceGroups) return false;

                return this.getSelectedEvent.eventPriceGroups.some(group => !group.isDeleted);
            },
            isLoadingStuff: function() {
                return false; // Disables loader
            }
        },
        created: function() {
            if (!this.getSelectedEvent.eventGenderPrices || this.getSelectedEvent.eventGenderPrices.length == 0) {
                this.updateType({id:1}); // Adds a pricing row of eventGenderPrices is empty
            }

            // This fixes the problem that if for some reason the event ends up without prices
            if (this.getSelectedEvent.eventGenderPrices.length == 0) {
                this.getSelectedEvent.eventGenderPrices = [
                    {
                        genderPriceType: 1,
                        vatType: 0,
                        value: 0,
                        currency: "€"
                    }
                ]
            }

            // VAT
            if (this.getSelectedEvent.eventGenderPrices) {
                for (let pricingRow of this.getSelectedEvent.eventGenderPrices) {
                    pricingRow.vatTypeHelper = this.taxes.filter((audienceType) => {
                        return audienceType.id == pricingRow.vatType;
                    })[0];
                }
            }
        },
        asyncComputed: {
            async types() {
                try {
                    this.isLoadingTypes = true;
                    let response = await axios.get('/api/settings/GetComponentExtraPriceTypeList');
                    this.isLoadingTypes = false;

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Set the pricing dropdow to "Per order" or "Per Person"
                        try {
                            if(this.getSelectedEvent.eventGenderPrices.length == 0){
                                this.selectedPrincingType = response.data[0];
                            } else {
                                if(this.getSelectedEvent.eventGenderPrices[0].genderPriceType == 1){
                                    this.selectedPrincingType = response.data[0];
                                } else {
                                    this.selectedPrincingType = response.data[1];
                                }
                            }
                        } catch (e) {
                            // Log the error
                            console.error('Error setting pricing type:', e);
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
            async audienceTypes() {
                try {
                    this.isLoadingAudienceTypes = true;
                    let response = await axios.get('/api/settings/GetAudienceTypeList');
                    this.isLoadingAudienceTypes = false;

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects
                        if (this.getSelectedEvent.eventGenderPrices) {
                            for (let pricingRow of this.getSelectedEvent.eventGenderPrices) {
                                if ([2, 3].includes(pricingRow.genderPriceType)) {
                                    pricingRow.audienceTypeHelper = response.data.filter((audienceType) => {
                                        return audienceType.id == pricingRow.audienceType;
                                    })[0];

                                    pricingRow.audienceTypeAssociationHelper = response.data.filter((audienceType) => {
                                        return audienceType.id === pricingRow.audienceTypeAssossiation;
                                    })[0];
                                }
                            }
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
        },
        methods:{
            ...mapActions([
                'openModal',
                'updateroductEditPriceData'
            ]),
            updateType: function(selectedType) {
                if (this.runUpdateTypeCounter > 0 || this.isCreatingSingleEvent) {
                    // adding a updateflag to Prices on editEvent
                    // this function is in mixin.js
                    this.eventActivateUpdateFlag('Prices');

                    if (selectedType.id == 1) {
                        if (!this.getSelectedEvent.eventGenderPrices || this.getSelectedEvent.eventGenderPrices.length == 0 || this.getSelectedEvent.eventGenderPrices === undefined || this.getSelectedEvent.eventGenderPrices[0].genderPriceType != 1) {
                            // console.log('setting princing to one row Per Order');
                            this.getSelectedEvent.eventGenderPrices = [
                                {
                                    genderPriceType: 1,
                                    vatType: 0,
                                    value: 0,
                                    currency: "€"
                                }
                            ]
                        }
                    } else {
                        if (this.audienceTypes && this.taxes && !this.getSelectedEvent.eventGenderPrices.genderPriceType && (this.getSelectedEvent.eventGenderPrices && this.getSelectedEvent.eventGenderPrices[0].genderPriceType != 2)) {
                            this.$set(this.getSelectedEvent, 'eventGenderPrices', [
                                {
                                    genderPriceType: 2,
                                    test: 'testing',
                                    audienceType: this.audienceTypes[0].id,
                                    audienceTypeHelper: this.audienceTypes[0],
                                    audienceTypeDescription: this.audienceTypes[0].description,
                                    value: 0,
                                    currency: '€',
                                    vatType: this.taxes[0].id,
                                    vatTypeHelper: this.taxes[0],
                                    productGenderPriceComponents: [
                                    ]
                                }
                            ])
                        }
                    }
                }

                this.runUpdateTypeCounter++; // Hacky way of prevent the first run of updateType that is triggered on created
            },
            updateAudienceType: function(row, selectedAudienceType) {
                row.audienceType = selectedAudienceType.id;
                // adding a updateflag to Prices on editEvent
                // this function is in mixin.js
                this.eventActivateUpdateFlag('Prices');
            },
            customPerPersonTaxes: function(row) {
                let taxes = [];
                for (let service of row) {
                    if (service.component.selectedPrice && taxes.indexOf(service.component.selectedPrice.vatType+'%') == -1) {
                        taxes.push(service.component.selectedPrice.vatType+'%');
                    }
                }
                return taxes.join(', ');
            },
            updateTaxType: function(row, selectedVatType){
                row.vatType = selectedVatType.id;
                // adding a updateflag to Prices on editEvent
                // this function is in mixin.js
                this.eventActivateUpdateFlag('Prices');
            },
            customPerPersonTotal: function(row) {
                let total = 0;
                for (let service of row) {
                    if (service.component.selectedPrice) {
                        total += service.component.selectedPrice.grossprice;
                    }
                }
                return (total).toFixed(2).replace(".", ",");
            },
            openEditPrice: function(priceRow) {
                if (!priceRow.editing) {
                    this.$set(priceRow, 'editing', true);
                } else {
                    this.$set(priceRow, 'editing', false);
                }
                this.updateroductEditPriceData(priceRow);
            },
            removePrincingAgeRow: function(index) {
                this.getSelectedEvent.eventGenderPrices.splice(index, 1);
                // adding a updateflag to Prices on editEvent
                // this function is in mixin.js
                this.eventActivateUpdateFlag('Prices');
            }
        },
        components: {
            vSelect: extendedVSelect,
            SplitPriceEditor,
            Loader,
            PricingManager
        }
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// areaPrices.vue?6affc587